module.exports = __webpack_public_path__ + "static/media/arnav.f8eee629.jpeg";